import { push } from 'react-router-redux'
import { getProjectList } from './projectList'
import { getCreationTime, logout, sendEmail } from '../Firebase/auth'

const AUTH_STATE_CHANGED = 'AUTH_STATE_CHANGED'
const USER_NAME_CHANGED = 'USER_NAME_CHANGED'
const EMAIL_CHANGED = 'EMAIL_CHANGED'
const USER_CREATING = 'USER_CREATING'
const USER_EMAIL_VERIFIED = 'USER_EMAIL_VERIFIED'
const USER_EMAIL_UNVERIFIED = 'USER_EMAIL_UNVERIFIED'

export const onAuthStateChanged = (userData) => {
  return (dispatch, getState) => {
    if (getState().authState.userCreating) {
      return
    }
    if (userData && userData.ct === undefined) {
      getCreationTime((userDataWithCT) => {
        dispatch(onAuthStateChanged0(userDataWithCT))
      }, (error) => {
        console.log(error)
        userData.ct = 0
        dispatch(onAuthStateChanged0(userData))
      })
      return
    }
    dispatch(onAuthStateChanged0(userData))
  }
}

export const onAuthStateChanged0 = (userData) => {
  return (dispatch, getState) => {
    if (!userData) {
      dispatch(onAuthStateChanged2(initialState))
      const pathName = getState().routing.location.pathname
      if (pathName.indexOf('/db') !== -1 || pathName.indexOf('/user') !== -1) {
        dispatch(push('/login'))
      }
      return
    }
    if (userData.emailVerified || checkCT(userData.ct)) {
      dispatch(onAuthStateChanged2(userData))
      dispatch(getProjectList())
      return
    }
    dispatch(onEmailExpiration(userData.email))
  }
}

export const onEmailExpiration = (email) => {
  return (dispatch, getState) => {
    let em = email ? email : getState().authState.email
    if (window.confirm(confirmMessage(em))) {
      sendEmail(() => alert(`Na adresu ${em} byl zaslán ověřovací e-mail.`),
        (error) => {
          console.log(error)
          alert('Zaslání ověřovacího e-mailu se nezdařilo. Zkuste to prosím později.')
        })
    }
    dispatch(onUserEmailUnverified())
    logout(() => {
      dispatch(onAuthStateChanged2(initialState))
    }, error => console.log(error))
  }
}

const checkCT = ct => {
  const d = new Date()
  return d.getTime() < ct
}

const confirmMessage = email => `Účet není dostupný - vypršela lhůta pro ověření e-mailové adresy ${email}. Proveďte prosím ověření kliknutím na odkaz v e-mailu, který jsme vám poslali. Pokud jste zadali chybnou e-mailovou adresu, proveďte novou registraci. Pokud je adresa správná, a přesto jste ověřovací e-mail nedostali, zkontrolujte nevyžádanou poštu. Pokud e-mail není ani tam, zkusíme vám poslat nový.

Poslat nový ověřovací e-mail?`

export const onAuthStateChanged2 = (userData) => {
  return {
    type: AUTH_STATE_CHANGED,
    payload: userData
  }
}

export const onUserCreating = (creating) => {
  return {
    type: USER_CREATING,
    payload: {
      creating: creating
    }
  }
}

export const onUserNameChanged = (userName) => {
  return {
    type: USER_NAME_CHANGED,
    payload: {
      userName: userName
    }
  }
}

export const onEmailChanged = (email) => {
  return {
    type: EMAIL_CHANGED,
    payload: {
      email: email
    }
  }
}

export const onUserEmailVerified = () => {
  return {
    type: USER_EMAIL_VERIFIED
  }
}

export const onUserEmailUnverified = () => {
  return {
    type: USER_EMAIL_UNVERIFIED
  }
}

const initialState = {
  login: false,
  name: null,
  email: null,
  emailVerified: false,
  emailUnverified: false,
  userCreating: false,
  uid: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case USER_CREATING:
      return {
        ...state,
        userCreating: action.payload.creating
      }
    case AUTH_STATE_CHANGED:
      return {
        ...state,
        ...action.payload
      }
    case USER_NAME_CHANGED:
      return {
        ...state,
        name: action.payload.userName
      }
    case EMAIL_CHANGED:
      return {
        ...state,
        email: action.payload.email
      }
    case USER_EMAIL_VERIFIED:
      return {
        ...state,
        emailVerified: true
      }
    case USER_EMAIL_UNVERIFIED:
      return {
        ...state,
        emailUnverified: true
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authState.js